/* eslint-disable */
// @ts-nocheck

import { ReactNode } from 'react'

import { Document, Font, Page, StyleSheet } from '@react-pdf/renderer'
import { DocumentProps, PageProps } from '@react-pdf/types'

import OpenSansBold from '@/assets/fonts/OpenSans/OpenSans-Bold.ttf'
import OpenSansRegular from '@/assets/fonts/OpenSans/OpenSans-Regular.ttf'

import Footer from './Footer'
import Header from './Header'

Font.register({
  family: 'OpenSans',
  fonts: [
    { src: OpenSansRegular },
    {
      src: OpenSansBold,
      fontWeight: 'bold',
    },
  ],
})

const styles = StyleSheet.create({
  page: {
    paddingTop: 28.9,
    paddingBottom: 57.8,
    paddingHorizontal: 28.9,
  },
})

const Layout = ({
  reportName,
  headerData,
  children,
  reportSettings,
  signLineTexts,
}: {
  reportName: string
  headerData: any
  children: ReactNode
  reportSettings?: {
    document?: Partial<DocumentProps>
    page?: Partial<PageProps>
  }
  signLineTexts?: string[]
}) => {
  return (
    <Document pdfVersion="1.7" title={reportName} {...reportSettings?.document}>
      <Page size="A4" style={styles.page} wrap {...reportSettings?.page}>
        <Header data={headerData} />
        {children}
        <Footer signLineTexts={signLineTexts} />
      </Page>
    </Document>
  )
}
export default Layout
